module.exports = __webpack_public_path__ + "img/icon-star-outline.56ceae1f.svg";